/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * VT Platform API
 * «Взлёт талантов» — REST API for children's creative competitions.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ListMyNotificationsParams,
  NotificationFeedEnvelope,
  ReadReceiptEnvelope
} from '../model-notifications';

import { customInstance } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listMyNotificationsResponse200 = {
  data: NotificationFeedEnvelope
  status: 200
}

export type listMyNotificationsResponseSuccess = (listMyNotificationsResponse200) & {
  headers: Headers;
};
;

export type listMyNotificationsResponse = (listMyNotificationsResponseSuccess)

export const getListMyNotificationsUrl = (params?: ListMyNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/me/notifications?${stringifiedParams}` : `/me/notifications`
}

/**
 * GET /api/v1/me/notifications — the caller's feed.
 * @summary List my notifications
 */
export const listMyNotifications = async (params?: ListMyNotificationsParams, options?: RequestInit): Promise<listMyNotificationsResponse> => {

  return customInstance<listMyNotificationsResponse>(getListMyNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyNotificationsQueryKey = (params?: ListMyNotificationsParams,) => {
    return [
    `/me/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMyNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listMyNotifications>>, TError = unknown>(params?: ListMyNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyNotifications>>> = ({ signal }) => listMyNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyNotifications>>>
export type ListMyNotificationsQueryError = unknown


export function useListMyNotifications<TData = Awaited<ReturnType<typeof listMyNotifications>>, TError = unknown>(
 params: undefined |  ListMyNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyNotifications>>,
          TError,
          Awaited<ReturnType<typeof listMyNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyNotifications<TData = Awaited<ReturnType<typeof listMyNotifications>>, TError = unknown>(
 params?: ListMyNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyNotifications>>,
          TError,
          Awaited<ReturnType<typeof listMyNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyNotifications<TData = Awaited<ReturnType<typeof listMyNotifications>>, TError = unknown>(
 params?: ListMyNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List my notifications
 */

export function useListMyNotifications<TData = Awaited<ReturnType<typeof listMyNotifications>>, TError = unknown>(
 params?: ListMyNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type markNotificationReadResponse200 = {
  data: ReadReceiptEnvelope
  status: 200
}

export type markNotificationReadResponseSuccess = (markNotificationReadResponse200) & {
  headers: Headers;
};
;

export type markNotificationReadResponse = (markNotificationReadResponseSuccess)

export const getMarkNotificationReadUrl = (notificationId: string,) => {




  return `/me/notifications/${notificationId}/read`
}

/**
 * POST /api/v1/me/notifications/{id}/read — mark one entry read.
 * @summary Mark one notification read
 */
export const markNotificationRead = async (notificationId: string, options?: RequestInit): Promise<markNotificationReadResponse> => {

  return customInstance<markNotificationReadResponse>(getMarkNotificationReadUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkNotificationReadQueryKey = (notificationId: string,) => {
    return [
    'POST', `/me/notifications/${notificationId}/read`
    ] as const;
    }


export const getMarkNotificationReadQueryOptions = <TData = Awaited<ReturnType<typeof markNotificationRead>>, TError = unknown>(notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarkNotificationReadQueryKey(notificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof markNotificationRead>>> = ({ signal }) => markNotificationRead(notificationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: notificationId !== null && notificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarkNotificationReadQueryResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>
export type MarkNotificationReadQueryError = unknown


export function useMarkNotificationRead<TData = Awaited<ReturnType<typeof markNotificationRead>>, TError = unknown>(
 notificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof markNotificationRead>>,
          TError,
          Awaited<ReturnType<typeof markNotificationRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarkNotificationRead<TData = Awaited<ReturnType<typeof markNotificationRead>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof markNotificationRead>>,
          TError,
          Awaited<ReturnType<typeof markNotificationRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarkNotificationRead<TData = Awaited<ReturnType<typeof markNotificationRead>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mark one notification read
 */

export function useMarkNotificationRead<TData = Awaited<ReturnType<typeof markNotificationRead>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarkNotificationReadQueryOptions(notificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type markAllNotificationsReadResponse200 = {
  data: ReadReceiptEnvelope
  status: 200
}

export type markAllNotificationsReadResponseSuccess = (markAllNotificationsReadResponse200) & {
  headers: Headers;
};
;

export type markAllNotificationsReadResponse = (markAllNotificationsReadResponseSuccess)

export const getMarkAllNotificationsReadUrl = () => {




  return `/me/notifications/read`
}

/**
 * POST /api/v1/me/notifications/read — mark the whole feed read.
 * @summary Mark every notification read
 */
export const markAllNotificationsRead = async ( options?: RequestInit): Promise<markAllNotificationsReadResponse> => {

  return customInstance<markAllNotificationsReadResponse>(getMarkAllNotificationsReadUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkAllNotificationsReadQueryKey = () => {
    return [
    'POST', `/me/notifications/read`
    ] as const;
    }


export const getMarkAllNotificationsReadQueryOptions = <TData = Awaited<ReturnType<typeof markAllNotificationsRead>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarkAllNotificationsReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof markAllNotificationsRead>>> = ({ signal }) => markAllNotificationsRead({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarkAllNotificationsReadQueryResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsRead>>>
export type MarkAllNotificationsReadQueryError = unknown


export function useMarkAllNotificationsRead<TData = Awaited<ReturnType<typeof markAllNotificationsRead>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof markAllNotificationsRead>>,
          TError,
          Awaited<ReturnType<typeof markAllNotificationsRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarkAllNotificationsRead<TData = Awaited<ReturnType<typeof markAllNotificationsRead>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof markAllNotificationsRead>>,
          TError,
          Awaited<ReturnType<typeof markAllNotificationsRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarkAllNotificationsRead<TData = Awaited<ReturnType<typeof markAllNotificationsRead>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mark every notification read
 */

export function useMarkAllNotificationsRead<TData = Awaited<ReturnType<typeof markAllNotificationsRead>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarkAllNotificationsReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






